export default __webpack_public_path__ + "static/media/sticker-z.ebf4e540.png";